import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { EDR_COLORS } from './edrTokens';
import { getMitreTechniqueDocsUrl } from './mitreDocs';

type EdrMitreDocsLinksProps = {
  ids: string[];
};

/** External MITRE ATT&CK documentation links for EDR detail screens. */
export const EdrMitreDocsLinks = ({ ids }: EdrMitreDocsLinksProps) => {
  if (!ids.length) return <>—</>;

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
      {ids.map((id) => (
        <Link
          key={id}
          href={getMitreTechniqueDocsUrl(id)}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 12,
            fontWeight: 600,
            color: EDR_COLORS.brand600,
            textDecoration: 'none',
          }}
        >
          <OpenInNewIcon style={{ fontSize: 14 }} />
          {id} — MITRE ATT&CK Documentation
        </Link>
      ))}
    </Box>
  );
};
